import { IS_DEV } from '@/utils/env';

export const setsterServices = {
  engagementRing: IS_DEV ? '56861' : '38158',
  weddingRing: IS_DEV ? '56862' : '38221',
  fineJewelryGifts: IS_DEV ? '56863' : '38313',
  pickUp: IS_DEV ? '56864' : '43034',
  dropOff: IS_DEV ? '56865' : '43035',
};
export const setsterServicesDateNight = {
  dateNightER: IS_DEV ? '62761' : '62806',
  dateNightWB: IS_DEV ? '62771' : '62807',
  dateNightFJ: IS_DEV ? '62772' : '62808',
};

export const DAYS_OF_DATE_NIGHT = ['Thu', 'Fri', 'Sat'];
